import { theme } from '../../../../../Assets/Styles/theme'

export const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 6,
    backgroundColor: theme.colors.primary,
    color: 'white',
    height: 26,
    minWidth: '80px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}
